var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPeak(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 78,
    height: 14,
    viewBox: "0 0 78 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_29_89)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.6821 4.6997C10.6821 7.23357 9.0548 9.24368 6.12007 9.24368H3.11579V13.0374C3.11579 13.6603 2.78198 14 2.16999 14H0.946029C0.334046 14 -0.0136719 13.6603 -0.0136719 13.0374V0.962588C0.000236827 0.339737 0.347954 0 0.959937 0H6.12007C9.08262 0 10.6821 2.17998 10.6821 4.6997ZM7.53875 4.71385C7.53875 3.55308 6.8155 2.67543 5.71671 2.67543H3.12969V6.70981H5.71671C6.8155 6.70981 7.53875 5.83215 7.53875 4.71385Z",
    fill: "#244A68"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.343 2.67543V5.83215H30.7799C31.3918 5.83215 31.7257 6.17189 31.7257 6.79474V7.33266C31.7257 7.95551 31.3918 8.3094 30.7799 8.3094H26.343V11.3104H31.5866C32.1985 11.3104 32.5324 11.6502 32.5324 12.273V13.0374C32.5324 13.6603 32.1985 14 31.5866 14H24.1871C23.5752 14 23.2274 13.6603 23.2274 13.0374V0.962588C23.2135 0.339737 23.5752 0 24.1871 0H31.5866C32.1985 0 32.5324 0.339737 32.5324 0.962588V1.727C32.5324 2.34985 32.1985 2.68959 31.5866 2.68959H26.343V2.67543Z",
    fill: "#244A68"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.8311 12.8959L52.1717 0.764409C51.977 0.254803 51.6293 0 51.0729 0H49.6821C49.1257 0 48.7641 0.254803 48.5833 0.764409L43.9795 12.8959C43.743 13.5612 44.0212 14 44.7306 14H45.9684C46.497 14 46.8586 13.7452 47.0533 13.2214L47.2202 12.7826L47.3454 12.457L47.4428 12.1456L50.4053 3.26997L52.7698 10.3337L53.799 13.4055C54.0077 13.816 54.3554 14.0142 54.8283 14.0142H56.1079C56.8172 14.0142 57.0954 13.5753 56.8589 12.91L56.8311 12.8959Z",
    fill: "#244A68"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.9387 6.92214L77.7636 1.06168C78.1809 0.39636 78.014 0 77.3185 0H75.7468C75.2322 0 74.8845 0.19818 74.6341 0.665318L71.004 6.39838V0.962588C71.004 0.339737 70.6702 0 70.0582 0H68.8342C68.2222 0 67.8745 0.339737 67.8745 0.962588V13.0374C67.8745 13.6603 68.2222 14 68.8342 14H70.0582C70.6702 14 71.004 13.6603 71.004 13.0374V7.60162L74.6341 13.3347C74.8845 13.7877 75.2461 14 75.7468 14H77.3185C78.0279 14 78.1809 13.6036 77.7636 12.9383L73.9387 6.92214Z",
    fill: "#244A68"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_29_89"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 78,
    height: 14,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPeak);
export default __webpack_public_path__ + "static/media/peak.aa62b0727ea2f2471737f5a4e9fbf01b.svg";
export { ForwardRef as ReactComponent };